export default "__VITE_ASSET__Cc$IH11a__"